<div id="register-pending">
    <div class="modal-content ">
        <div class="modal-header d-block mt-5 border-0 text-center">
          <img *ngIf="check==='ok'" src="assets/images/body/reserva-ok.svg" class="mt-5" alt="">
          <h3 class="modal-title text-secondary text-center m-auto" id="loginLabel" style="color: #0099ff;">{{titulo}}</h3>
          <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button> -->
          <i class="bi-x modal-close" aria-label="Close" (click)="activeModal.dismiss('Cross click')"></i>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-1"></div>
            <div class="col-10 text-center">
              <p class="mb-5">{{texto}}</p>
              <a [routerLink]="[ruta]" class="btn btn-lg btn-primary btn-reservar rounded-pill" (click)="activeModal.dismiss('Cross click')" >{{label}}</a>
            </div>
            <div class="col-1"></div>
            
          </div>
        </div>
        <div class="modal-footer mb-5 border-0">
          <img src="assets/images/body/register-pending-1.svg" class="left" alt="">
          <img src="assets/images/body/register-pending-2.svg" class="right" alt="">
        
        </div>
      </div>    
  </div>
